import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEditService } from '../../../tms-shared';
import { Role, RoleDetails, RoleDocument, RoleMenuItem, UpdateRoleMenuItem } from '../models';

@Injectable({
  providedIn: 'root',
})
export class RoleService extends BaseEditService<Role, RoleDetails> {
  constructor() {
    super('Role', $localize`Role`);
  }

  getRoleMenuItems(roleId: string): Observable<RoleMenuItem[]> {
    return this.httpService.get<RoleMenuItem[]>(`${this.apiUrl}/GetRoleMenuItems/${roleId}`);
  }

  updateRoleMenuItems(roleId: string, menuItems: UpdateRoleMenuItem[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateRoleMenuItems`, { roleId, menuItems });
  }

  getRoleDocuments(roleId: string): Observable<RoleDocument[]> {
    return this.httpService.get<RoleDocument[]>(`${this.apiUrl}/GetRoleDocuments/${roleId}`);
  }

  updateRoleDocuments(roleId: string, documentIds: string[]): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateRoleDocuments`, { roleId, documentIds });
  }
}
